<div
  id="responsive-layout-container"
  class="responsive-layout-wrapper"
  [ngClass]="getClass()"
>
  <div id="responsive-layout-wrapper-text" class="responsive-layout-text-wrapper">
    <app-text
      id="responsive-layout-desktop-text"
      [textStyleType]="'headline2'"
      *ngIf="!overline"
    >
      {{ titleKey | translate }}
    </app-text>

    <app-title-subtitle
      id="responsive-layout-inner-text"
      *ngIf="overline"
      [title]="overline!"
      [subtitle]="titleKey | translate"
      [alignment]="'left'"
      [titleFontStyle]="'overline'"
      [subtitleFontStyle]="'headline2'"
    >
    </app-title-subtitle>
  </div>

  <div id="responsive-layout-content" class="responsive-layout">
    <ng-content
      id="responsive-layout-select"
      select=".responsive-layout-content"
    ></ng-content>
  </div>
</div>
